/* ------------------------------------------------------------------
   ONE CHAMPIONSHIP — editable copy.

   All the wording for the ONE Championship band lives here so the
   announcement can be kept up to date without touching the layout.
   Sourced from the gym's own channels (agosto 2026): Valentina
   Cancello, 18 anni, ha debuttato a ONE Championship a Bangkok
   grazie alla collaborazione con il Kiatsongrit Gym.
------------------------------------------------------------------ */

export const oneChampionship = {
    kicker: 'Nuovo capitolo',
    title: 'ONE CHAMPIONSHIP',
    headline: 'Dal tatami di Saviano al ring più grande del mondo.',
    lead:
        "La nostra atleta Valentina Cancello, 18 anni, ha debuttato a ONE Championship a Bangkok. " +
        "Un'opportunità nata dal lavoro quotidiano in palestra e dalla collaborazione con il Kiatsongrit Gym. " +
        "Chi vince festeggia e chi perde riflette: noi torniamo ad allenarci.",

    /* Proof points shown under the headline. */
    stats: [
        { value: 'ONE', label: 'Debutto internazionale' },
        { value: '18', label: "Anni dell'atleta" },
        { value: '11', label: 'Khan Muay Thai' },
    ],

    /* Scrolling marquee strip above the band. */
    ticker: [
        'ONE CHAMPIONSHIP',
        'FORTI E FIERI',
        'TEAM VIVENZIO',
        'BANGKOK — SAVIANO',
    ],

    /* Athlete featured in the band. */
    athlete: {
        name: 'Valentina Cancello',
        role: 'Nak Muay Ying — Team Vivenzio',
        instagram: 'https://www.instagram.com/valentinacancello/',
    },

    /* Photo shown beside the announcement — Valentina in the ONE ring at
       Lumpinee, Mario in the corner behind her. If you swap the file in
       OneChampionship.js, update these three strings with it. */
    image: {
        alt: 'Valentina Cancello sul ring di ONE Championship a Bangkok',
        caption: 'VALENTINA CANCELLO',
        subCaption: 'ONE Lumpinee — Bangkok',
    },

    /* Thai camps the team trains with. */
    camps: [
        { name: 'Kiatsongrit Gym', link: 'https://www.instagram.com/kiatsongrit_gym/' },
        { name: 'Kiatpetch Gym', link: '' },
        { name: 'Rithirit Gym', link: '' },
    ],

    instagram: 'https://www.instagram.com/mario__vivenzio/',
};
